module.exports = __webpack_public_path__ + "img/companyright.89f15a4c.png";